export const MARKETS_TO_VALIDATE_ADDRESS = ['sk', 'bg', 'ee'];
